<template>
  <page :loading="loading">
    <div class=" flex items-center" slot="title">
      <input-box v-model="searchText" class="flex-1" placeholder="大家都在搜什么" active focus></input-box>
      <btn size="sm" class="ml-2" @click="search">搜索</btn>
    </div>
    <list :empty="!list.length">
      <media-item 
        v-for="(item,index) in list" 
        :key="index"
        :title="item.title"
        :image="item.image"
      ></media-item>
    </list>
  </page>
</template>

<script>
import {mapGetters} from 'vuex'
export default {
  data() {
    return {
      searchText: '',
      list: [],
      loading: false
    }
  },
  computed: {
    ...mapGetters([
      'TestData'
    ])
  },
  methods:{
    search() {
      this.loading = true
      console.log(this.searchText);
      this.getList() ;
    },
    getList() {
      this.list = this.TestData.videoList
      this.loading = false
    }
  },
  created() {

  }
}
</script>

<style>

</style>